import React, {useEffect, useState} from 'react';
import Wrapper from "../components/Wrapper.js";
import {useParams} from "react-router-dom";
import Loader from "../components/BlueButton/Loader.js";
import {word} from "../word.js";
import Api from '../Api.js'
import {useSelector} from "react-redux";
import MyImgRound from "../components/MyImgRound.js";
import {useNavigate} from "react-router-dom";
import EditRepeatedTask from "../components/RepearedTaskComponents/EditRepeatedTask.js";

function RepeatedTaskPage(props) {
    const {id} = useParams();
    const manager = useSelector((state) => state.manager.employee);
    const navigate = useNavigate()
    const [data, setData] = useState({});
    const [show, setShow] = useState(false);
    const [copy, setCopy] = useState(false);
    const [showPicker, setShowPicker] = useState(false);
    const renderRepeatedType = (type) => {
        switch (type) {
            case 1:
                return word.daily;
            case 2:
                return word.weekly;
            case 3:
                return word.monthly;
            case 4:
                return word.annual;
            default:
                return '';
        }
    };
    const onHide = async () => {
        try {
            if(copy){
                setCopy(false)
            }else{
                setShow(false)
            }
            const {data} = await Api.repeatedSingleTasks(id);
            setData(data)
        }catch (e) {

        }
    }
    useEffect(() => {
        (async () => {
            try {
                const {data} = await Api.repeatedSingleTasks(id);
                setData(data)
            }catch (e) {

            }
        })()
    }, [id]);

    return (
        <Wrapper>
            <div className='recommendation-page'>
                {!data.url?
                    <Loader size={30}/>
                :
                <div className="repeated-task-cont">
                    <div className="icon-Compose-cont">
                        <div className="tool-tip-cont">
                            <div className="tool-tip">Պատճենել</div>
                            <i className="fas fa-copy" onClick={() => setCopy(true)}/>
                        </div>

                        {manager.url && data.creator === manager.user.url && (
                            <div className="tool-tip-cont">
                                <div className="tool-tip">Խմբագրել</div>
                                <span onClick={() => setShow(true)} className='icon-Compose'/>
                            </div>
                        )}
                    </div>

                    <a onClick={() => navigate(-1)} className="link-Backward-arrow">
                        <span className="icon-Backward-arrow"/>
                    </a>

                    <div className='employee-name' onClick={() => setShow(true)}>
                        {data.accountant_image && <MyImgRound image={data.accountant_image}/>}
                        <span>{data.accountant_first_name} <br/>{data.accountant_last_name}</span>
                    </div>

                    <div
                        className='company-name repeated-task-page'
                        onClick={() => navigate(`/main_employee/organization/${data.company_id}`)}
                    >
                        {data.company_name}
                    </div>

                    <h1>{data.name}</h1>

                    <div className="repeated-task-data">
                        <span>{word.repeated_type}</span>
                        <p>{renderRepeatedType(data.repeated_type)}</p>
                    </div>
                    <div className="repeated-task-data">
                        <span>{word.duration}</span>
                        <p>{data.duration}</p>
                    </div>
                    <div className="repeated-task-data">
                        <span>{word.repeated_value}</span>
                        <p>{data.repeated_value}</p>
                    </div>
                    <div className="repeated-task-data">
                        <span>{word.accountant_name}</span>
                        <p>{data.accountant_first_name} {data.accountant_last_name}</p>
                    </div>
                    <div className="repeated-task-data">
                        <span>{word.text}</span>
                        <p>{data.text}</p>
                    </div>
                </div>}
                {show || copy ? <EditRepeatedTask data={data} copy={copy} show={show || copy} onHide={onHide}/> : null}
            </div>
        </Wrapper>
    );
}

export default RepeatedTaskPage;